import { Backdrop, CircularProgress } from "@mui/material";

import styles from "./PageLoader.module.scss";

interface IProps {
    loading: boolean;
    value?: string;
}
const PageLoader = ({ loading, value }: IProps) => {
    const loaderValue = () => {
        const numericValue = Number(value);
        if (value === "undefined" || Number.isNaN(numericValue)) {
            return "0 %";
        }
        return `${Math.min(Math.max(Math.floor(numericValue), 0), 100)} %`;
    };
    return (
        <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            data-testid='loader'
        >
            <div className={styles.loaderBox}>
                <CircularProgress
                    color='inherit'
                    style={{ width: "56px", height: "56px" }}
                    data-testid='circular-progress'
                />
                {value && (
                    <div className={styles.value} data-testid='status'>
                        {loaderValue()}
                    </div>
                )}
            </div>
        </Backdrop>
    );
};
export default PageLoader;
